import Flex from 'components/common/Flex';
import IconItem from 'components/common/icon/IconItem';
import SoftBadge from 'components/common/SoftBadge';
import { MailSendMode, TemplatesModel } from 'types';
import EmailActionTrigger from '../MailRequestsTable/EmailActionTrigger';
import { faToggleOn, faToggleOff, faEye, faEllipsisH } from '@fortawesome/free-solid-svg-icons';
import { Dropdown } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ActionDropdown from 'components/common/ActionDropdown';

type CellRow<T> = { original: T };

type ColumnsProps = {
  t: (key: string) => string;
  onToggleSendMode: (guid: string, mode: MailSendMode) => void;
  onEdit: (template: TemplatesModel) => void;
  onEditExpiryDays: (template: TemplatesModel) => void;
};

export default function columns({
  t,
  onToggleSendMode,
  onEdit,
  onEditExpiryDays
}: ColumnsProps) {
  return [
    {
      accessorKey: 'templateKey',
      header: t('template'),
      cell: ({ row }: { row: CellRow<TemplatesModel> }) => (
        <Flex alignItems="center">
          <strong>{row.original.templateKey}</strong>
        </Flex>
      )
    },
		{
			accessorKey: 'subject',
			header: t('subject'),
		},
    {
      accessorKey: 'language',
      header: t('language'),
      meta: { cellProps: { className: 'text-center' } }
    },
    {
      accessorKey: 'sendMode',
      header: t('send_mode'),
      meta: { cellProps: { className: 'text-center' } },
      cell: ({ row }: { row: CellRow<TemplatesModel> }) => {
        const mode = row.original.sendMode;

        const map: Record<MailSendMode, { bg: 'success' | 'warning' | 'danger'; label: string }> = {
          [MailSendMode.Auto]: { bg: 'success', label: 'ON' },
          [MailSendMode.Manual]: { bg: 'warning', label: 'OFF' },
          [MailSendMode.Disabled]: { bg: 'danger', label: 'OFF' }
        };

        const config = map[mode] ?? { bg: 'danger', label: '-' };

        return (
          <SoftBadge pill bg={config.bg}>
            {config.label}
          </SoftBadge>
        );
      }
    },
    {
      id: 'actions',
      header: t('actions'),
      enableSorting: false,
      meta: {
        headerProps: { className: 'text-end' },
        cellProps: { className: 'text-end' }
      },

      cell: ({ row }: { row: CellRow<TemplatesModel> }) => {
        const tpl = row.original;
        const isAuto = tpl.sendMode === MailSendMode.Auto;

        return (
          <ActionDropdown btnRevealClass="btn-reveal-sm" drop="start">
              <div className="py-2">
                <Dropdown.Item
                  onClick={() =>
                    onToggleSendMode(
                      tpl.guid,
                      isAuto ? MailSendMode.Manual : MailSendMode.Auto
                    )
                  }
                >
                    <div className="d-flex align-items-center justify-content-between w-100">
                    <span>{isAuto ? t('set_manual') : t('set_auto')}</span>
                    <FontAwesomeIcon
                      icon={isAuto ? faToggleOn : faToggleOff}
                      className="ms-3"
                    />
                  </div>
                </Dropdown.Item>

                <Dropdown.Item onClick={() => onEdit(tpl)}>
                  {t('edit')}
                </Dropdown.Item>
                
                {tpl.templateKey === 'Licence.ExpiryWarning' && (
                  <Dropdown.Item onClick={() => onEditExpiryDays(tpl)}>
                    {t('edit_expiry_days')}
                  </Dropdown.Item>
                )}

              </div>
          </ActionDropdown>
        );
      }
    }
  ];
}
